import { css } from '@styles/theme'

export const HexAvatarStyles = {
	wrapper: css({
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	}),

	svg: css({
		width: '100%',
		height: '100%',

		'use:last-of-type': {
			stroke: '$neutral10',
		},
	}),

	initial: css({
		position: 'absolute',
		color: '$neutral10',
		fontWeight: 600,
		fontFamily: 'Roboto, sans-serif',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		height: '100%',
		pointerEvents: 'none',
	}),
}
